import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";
import { firebaseConfig } from '../config';

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

export const storageAvatarRef = ref(storage, 'avatars');
export const storageDocumentosRef = ref(storage, 'documents');
